<!--<div class="photoView" (click)="takePhoto()">
  @if (working) {
  <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
  } @else {
  <div class="angle-image-container">
    @if (photo.data) {
    <mat-icon class="delete-icon" (click)="deletePhoto($event)">cancel</mat-icon>
    <img [src]="'data:image/jpg;base64,' + photo.data" class="image-box" />
    } @else if (photo.taken) {
    <img [src]="fallbackImage" class="image-box" />
    } @else {
    @if (photo.angle) {
    <img [src]="photo.angle.ImageUri" class="image-box-default" />
    } @else {
    <div class="photo-icon"></div>
    }
    }
  </div>
  }
</div>-->

<div class="photoView" (click)="$event.stopPropagation()">

  @if(photo?.photoUri || photo?.data){
  <div class="photo-wrap">
    @if(photo.photoUri){
    <img class="photo-img" [src]="photo.photoUri" />
    }
    @else if(photo.data){
    <img [src]="'data:image/jpg;base64,' + photo.data" class="photo-img" />
    }
    @else{
    <img class="photo-img" [src]="fallbackImage" />
    }

    <button mat-icon-button
            class="delete-icon"
            (click)="deletePhoto($event)"
            title="Delete"
            type="button">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  }

  @if(!cameraOpen){
  @if(photo.angle && !photo?.photoUri && !photo?.data && !cameraLoading){
  <img [src]="photo.angle.ImageUri" class="image-box-default" />
  }
  }

  @if(showCameraOverlay){
  <div class="camera-overlay" style="position:relative">
    @if(cameraLoading){
    <div style="position: absolute; top: 45%; left: 50%; transform: translate(-50%, -50%); z-index: 10; pointer-events: none;">
      <mat-spinner></mat-spinner>
    </div>
    }
    <video #video
           autoplay
           playsinline
           muted
           class="camera-video"
           [class.hidden]="!videoReady">
    </video>
    <canvas #canvas hidden></canvas>
  </div>
  }


  @if(additionalPhoto && !cameraOpen && !photo?.photoUri && !photo?.data){
  <div class="photo-icon" (click)="startBrowserCamera()"></div>

  }
  @else if(additionalPhoto && cameraOpen && !photo?.photoUri){
  <button mat-raised-button color="primary" (click)="captureAndUpload()">{{'Intellitrailer.Rental.PhotoBtn.TakePicture' | translate: 'Take Picture'}}</button>
  }
</div>



